"use strict";
/// <reference path="Mail.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mail = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
const $ = require("jquery");
const Utilities_1 = require("../../javascript/Utilities");
const synerisMethods_1 = require("../Menu/synerisMethods");
require("../../templates/insertMailPE.less");
const Instance_1 = require("../../model/Instance");
const Base_1 = require("../../model/Base");
let _ = require("underscore");
let moment = require("moment");
class Mail {
    static init($elem, options) {
        return $elem.each(function () {
            const $this = $(this);
            let synData = $elem.data("synMail");
            if (!synData) {
                $elem.trigger("beginInit");
                $elem.data("synMail", $.extend({
                    context: undefined,
                    maxitems: 20
                }, options));
                synData = $elem.data("synMail");
                synData.mailItems = {
                    messages: [],
                    attachments: [],
                    GUIDsToImport: []
                };
                synData.importFileItems = {};
                synData.doCloseDropdown = undefined;
                synData.ajaxCallInProgress = false;
                let mailContainer = $elem
                    .tooltip({
                    html: true,
                    delay: 500,
                    placement: "left",
                    selector: "div.mailtooltip"
                })
                    .addClass("synMail dropdown");
                let dropDownButton = $("<button class='btn dropdown-toggle' type='button' data-toggle='dropdown'>")
                    .attr("title", Utilities_1.synUtil.Strings.getValue("mailimport", "Import mails"))
                    .appendTo(mailContainer);
                dropDownButton.append("<i class='fa fa-sign-in' />");
                $("<span class='badge' />").appendTo(dropDownButton);
                $("<div class='mail_items dropdown-menu' />").appendTo(mailContainer);
                dropDownButton.dropdown();
                let refreshMails = function () {
                    $.when(Mail.getMails($this), Mail.getAttachments($this), Mail.getImportFiles($this)).done(function () {
                        Mail.render($this);
                    });
                };
                mailContainer.on('show.bs.dropdown', function () {
                    refreshMails();
                });
                refreshMails();
                $elem.trigger("initSuccess");
                $elem.trigger("endInit");
            }
        });
    }
    static empty($elem) {
        return $elem.each(function () {
            const synData = $elem.data('synMail');
            let fileGuids = [];
            _.each(synData.mailItems.messages, function (item) {
                fileGuids.push(item.fileGuid);
            });
            Mail.deleteMails($elem, fileGuids);
            fileGuids = [];
            _.each(synData.mailItems.attachments, function (item) {
                fileGuids.push(item.fileGuid);
            });
            Mail.deleteAttachmentsOrImportFiles($elem, fileGuids);
        });
    }
    static refresh($elem, fileGuids, tabParentId, tabRelId) {
        return $elem.each(function () {
            $.when(Mail.getMails($elem, fileGuids, tabParentId, tabRelId), Mail.getAttachments($elem), Mail.getImportFiles($elem)).done(function () {
                Mail.render($elem);
            });
        });
    }
    static getAttachmentsToImport($elem) {
        const synData = $elem.data('synMail');
        let guidsToImport = synData.mailItems.GUIDsToImport;
        let result = [];
        if (guidsToImport.length > 0) {
            let attachmentMap = {};
            for (let i = 0; i < synData.mailItems.attachments.length; ++i)
                attachmentMap[synData.mailItems.attachments[i].fileGuid] = synData.mailItems.attachments[i];
            for (let i = 0; i < guidsToImport.length; ++i) {
                let curGuid = guidsToImport[i];
                let item = attachmentMap[curGuid];
                if (!item)
                    item = synData.importFileItems[curGuid];
                if (item) {
                    let ext = item.filename.split("."), extension;
                    if (ext.length === 1 || (ext[0] === "" && ext.length === 2))
                        extension = "";
                    else
                        extension = "." + ext.pop();
                    result.push({
                        filename: item.filename,
                        name: item.filename,
                        extension,
                        fileGuid: item.fileGuid
                    });
                }
            }
        }
        return result;
    }
    static attachmentsImported($elem, importedGUIDS) {
        const synData = $elem.data('synMail');
        let GUIDsToImport = synData.mailItems.GUIDsToImport;
        let GUIDsToRemove = _.intersection(GUIDsToImport, importedGUIDS);
        synData.mailItems.GUIDsToImport = [];
        Mail.deleteAttachmentsOrImportFiles($elem, GUIDsToRemove);
    }
    static attachmentsImportCancelled($elem) {
        const synData = $elem.data('synMail');
        synData.mailItems.GUIDsToImport = [];
    }
    static destroy($elem) {
        return $elem.each(function () {
            const $this = $(this);
            $(this).off("beginInit");
            $(this).off("initSuccess");
            $(this).off("endInit");
            $(this).off("afterCopy");
            $(this).off("afterInsert");
            $(this).off("afterDelete");
            $(this).off("needContext");
            $this.removeData('synMail');
        });
    }
    static getMails($elem, fileGuids, tabParentId, tabRelId) {
        let d = $.Deferred();
        const synData = $elem.data('synMail');
        synData.mailItems.messages = [];
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("IntegrationGetMailReferences"),
            done(data) {
                let mailRef = {};
                for (let i = 0; i < data.length; i++) {
                    mailRef.fileGuid = data[i].fileGuid;
                    mailRef.subject = data[i].Subject;
                    mailRef.name = mailRef.subject;
                    mailRef.senderName = data[i].MailSender;
                    mailRef.to = data[i].MailTo;
                    mailRef.cc = data[i].MailCC;
                    mailRef.sentOn = Utilities_1.synUtil.jsonToDateTime(data[i].MailDate).toString();
                    Mail.addToMaillist($elem, mailRef);
                }
                if (tabParentId != undefined)
                    Mail.autoImportMails($elem, fileGuids, tabParentId, tabRelId);
                d.resolve(data);
            }
        });
        return d.promise();
    }
    static getAttachments($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let d = $.Deferred();
            const synData = $elem.data('synMail');
            synData.mailItems.attachments = [];
            Utilities_1.synUtil.getAJAXData({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("IntegrationGetAttachmentReferences"),
                done(data) {
                    let mailRef = {};
                    for (let i = 0; i < data.length; i++) {
                        mailRef.fileGuid = data[i].fileGuid;
                        mailRef.filename = data[i].filename;
                        Mail.addToAttachmentlist($elem, mailRef);
                    }
                    d.resolve(data);
                }
            });
            return d.promise();
        });
    }
    static getImportFiles($elem) {
        let d = $.Deferred();
        const synData = $elem.data('synMail');
        synData.importFileItems = {};
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("IntegrationGetImportFileReferences"),
            done(data) {
                for (let i = 0; i < data.length; i++)
                    Mail.addToImportFileList($elem, data[i]);
                d.resolve(data);
            }
        });
        return d.promise();
    }
    static addToMaillist($elem, mailObject) {
        const synData = $elem.data('synMail');
        let matchItem = _.findWhere(synData.mailItems, { fileGuid: mailObject.fileGuid });
        if (!matchItem) {
            synData.mailItems.messages.push({
                fileGuid: mailObject.fileGuid,
                subject: mailObject.subject,
                senderName: kendo.htmlEncode(mailObject.senderName),
                to: kendo.htmlEncode(mailObject.to),
                cc: kendo.htmlEncode(mailObject.cc),
                sentOn: kendo.htmlEncode(mailObject.sentOn)
            });
            $elem.trigger("afterCopy", [mailObject.subject]);
        }
    }
    static autoImportMails($elem, fileGuids, tabParentId, tabRelId) {
        let importBehavior = Utilities_1.synUtil.Configs.getValue("webtoolkitmailimportdefault", "import");
        if (importBehavior === 'import')
            Mail.insertMails($elem, fileGuids, tabParentId, tabRelId);
        else if (importBehavior === 'importpe')
            Mail.insertMailPE($elem, fileGuids[0], tabParentId, tabRelId);
    }
    static addToAttachmentlist($elem, mailObject) {
        const synData = $elem.data('synMail');
        let matchItem = _.findWhere(synData.mailItems, { fileGuid: mailObject.fileGuid });
        if (!matchItem) {
            synData.mailItems.attachments.push({
                fileGuid: mailObject.fileGuid,
                filename: kendo.htmlEncode(mailObject.filename),
                size: 0
            });
            $elem.trigger("afterCopy", [mailObject.filename]);
        }
    }
    static addToImportFileList($elem, importFile) {
        const synData = $elem.data('synMail');
        synData.importFileItems[importFile.fileGuid] = importFile;
    }
    static getParentContext($elem) {
        const synData = $elem.data("synMail");
        $elem.trigger("needContext");
        let parentId = synData.context.parentContext.parentId;
        let relId = synData.context.parentContext.parentRelId;
        return {
            parentId,
            relId
        };
    }
    static insertMails($elem, fileGuids, parentId, relId) {
        const synData = $elem.data('synMail');
        if (parentId == undefined) {
            let parentContext = Mail.getParentContext($elem);
            parentId = parentContext.parentId;
            relId = parentContext.relId;
        }
        if (parentId && !synData.ajaxCallInProgress) {
            synData.ajaxCallInProgress = true;
            Utilities_1.synUtil.getAJAXData({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("IntegrationImportMails") + parentId + "/" + (relId == undefined ? '' : relId),
                requestData: { fileguids: fileGuids.join(";"), parentId, relId },
                done(data) {
                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("mailsimported"));
                    synData.ajaxCallInProgress = false;
                    $elem.trigger("afterInsert", fileGuids);
                    $.when(Mail.getMails($elem)).done(function () {
                        Mail.render($elem);
                    });
                },
                cleanUp() {
                    synData.ajaxCallInProgress = false;
                }
            });
        }
        Mail.keepDropdownOpen($elem);
    }
    static insertMailPE($elem, fileGuid, parentId, relId) {
        const synData = $elem.data('synMail');
        if (parentId == undefined) {
            let parentContext = Mail.getParentContext($elem);
            parentId = parentContext.parentId;
            relId = parentContext.relId;
        }
        if (parentId && !synData.ajaxCallInProgress) {
            synData.ajaxCallInProgress = true;
            Utilities_1.synUtil.beginAjaxProgress();
            Utilities_1.synUtil.getAJAXData({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("IntegrationGetMailInstances") + parentId + "/" + (relId == undefined ? '' : relId),
                requestData: { fileguids: fileGuid, parentId, relId },
                done(dataJSON) {
                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                        let mailInstance = yield Instance_1.Instance.fromJSON(dataJSON[0]);
                        let markup = require("../../templates/insertMailPE.tmpl.html");
                        // Create Window
                        let windowData = Utilities_1.synUtil.popupWindow({
                            title: Utilities_1.synUtil.Strings.getValue("insertMailPE"),
                            actions: ["Maximize", "Close"],
                            width: 1040,
                            height: 600,
                            resizable: true,
                            modal: true,
                            synDesktopAware: false
                        });
                        // Initialize contents
                        let configData = {
                            synUtil: Utilities_1.synUtil,
                            windowID: "popup_" + windowData.guid,
                            splitterId: "splitter_" + windowData.guid,
                            propPageId: "propPage_" + windowData.guid,
                            okButtonId: "okButton_" + windowData.guid,
                            okCloseButtonId: "okCloseButton_" + windowData.guid,
                            cancelButtonId: "cancelButton_" + windowData.guid
                        };
                        // Create HTML from template
                        let template = kendo.template(markup);
                        windowData.contentDiv.html(template(configData));
                        // proppage
                        let propPagePane = $("#" + configData.propPageId);
                        propPagePane
                            .on("instanceChanged", function () {
                            let diff = new Instance_1.Instance();
                            $.each(mailInstance.items, function (idx, field) {
                                if (field.value != undefined)
                                    diff.items[field.name] = field;
                            });
                            propPagePane.synPropertyPage("changeInstance", diff);
                        })
                            .on("endInit", function () {
                            propPagePane.synPropertyPage("setTemplate", {
                                mode: Base_1.PropertyPageMode.New,
                                parentId,
                                parentRelId: relId,
                                typeId: mailInstance.items["cgdocument.typeid"].valueToNumber(1)
                            });
                        })
                            .synPropertyPage();
                        let saveMail = function (openNewDocumentInTab) {
                            Utilities_1.synUtil.beginAjaxProgress("#" + configData.okButtonId);
                            Utilities_1.synUtil.beginAjaxProgress("#" + configData.okCloseButtonId);
                            let inst = propPagePane.synPropertyPage("getInstance");
                            Utilities_1.synUtil.getAJAXData({
                                method: "POST",
                                url: Utilities_1.synUtil.getWSUrl("IntegrationCreateMailInstance") + parentId + "/" + ((relId == undefined) ? '' : relId),
                                requestData: {
                                    fileguid: fileGuid,
                                    parentId,
                                    relId,
                                    instanceData: JSON.stringify(inst.toJSON())
                                },
                                done(instJSON) {
                                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                        Mail.deleteMails($elem, [fileGuid]);
                                        $elem.trigger("afterInsert", [fileGuid]);
                                        if (openNewDocumentInTab === true) {
                                            let newInstance = yield Instance_1.Instance.fromJSON(instJSON);
                                            window.open("#/properties?id=" + newInstance.id.value, "_blank");
                                        }
                                        $.when(Mail.getMails($elem)).done(function () {
                                            Mail.render($elem);
                                        });
                                        $("#" + configData.windowID).data("kendoWindow").close();
                                    });
                                },
                                cleanUp() {
                                    Utilities_1.synUtil.endAjaxProgress("#" + configData.okButtonId);
                                    Utilities_1.synUtil.endAjaxProgress("#" + configData.okCloseButtonId);
                                }
                            });
                        };
                        // OK button click event
                        $("#" + configData.okButtonId).on("click", function () {
                            saveMail(true);
                        });
                        $("#" + configData.okCloseButtonId).on("click", function () {
                            saveMail(false);
                        });
                        // Cancel button click event
                        $("#" + configData.cancelButtonId).on("click", function () {
                            $("#" + configData.windowID).data("kendoWindow").close();
                        });
                    });
                },
                cleanUp() {
                    synData.ajaxCallInProgress = false;
                    Utilities_1.synUtil.endAjaxProgress();
                }
            });
        }
        Mail.keepDropdownOpen($elem);
    }
    static insertAttachmentsOrFiles($elem, fileGuids) {
        const synData = $elem.data('synMail');
        let parentContext = Mail.getParentContext($elem);
        if (parentContext.parentId != undefined) {
            synData.mailItems.GUIDsToImport = fileGuids;
            if (fileGuids.length === 1)
                synerisMethods_1.synerisMethods.cefunc["111"].impl(undefined, parentContext.parentId, parentContext.relId);
            else
                synerisMethods_1.synerisMethods.guimethods.multidocnew.impl(undefined, parentContext.parentId, parentContext.relId);
        }
    }
    static deleteMails($elem, fileGuids) {
        const synData = $elem.data('synMail');
        if (!synData.ajaxCallInProgress && fileGuids.length > 0) {
            synData.ajaxCallInProgress = true;
            Utilities_1.synUtil.getAJAXData({
                method: "PUT",
                url: Utilities_1.synUtil.getWSUrl("IntegrationDeleteMails"),
                requestData: { fileguids: fileGuids.join(";") },
                done(data) {
                    synData.ajaxCallInProgress = false;
                    $elem.trigger("afterDelete", fileGuids);
                    $.when(Mail.getMails($elem)).done(function () {
                        Mail.render($elem);
                    });
                },
                cleanUp() {
                    synData.ajaxCallInProgress = false;
                }
            });
        }
        Mail.keepDropdownOpen($elem);
    }
    static deleteAttachmentsOrImportFiles($elem, fileGuids) {
        const synData = $elem.data('synMail');
        let attachmentMap = {};
        for (let i = 0; i < synData.mailItems.attachments.length; ++i)
            attachmentMap[synData.mailItems.attachments[i].fileGuid] = synData.mailItems.attachments[i];
        let attachmentGuids = [];
        let importFileGuids = [];
        for (let i = 0; i < fileGuids.length; ++i) {
            let curGuid = fileGuids[i];
            if (attachmentMap[curGuid])
                attachmentGuids.push(curGuid);
            else if (synData.importFileItems[curGuid])
                importFileGuids.push(curGuid);
        }
        let promises = [];
        if (attachmentGuids.length > 0)
            promises.push(Mail.deleteAttachmentsOrImportFilesCore($elem, true, attachmentGuids));
        if (importFileGuids.length > 0)
            promises.push(Mail.deleteAttachmentsOrImportFilesCore($elem, false, importFileGuids));
        $.when.apply($, promises).then(function () {
            let refreshPromises = [];
            if (attachmentGuids.length > 0)
                refreshPromises.push(Mail.getAttachments($elem));
            if (importFileGuids.length > 0)
                refreshPromises.push(Mail.getImportFiles($elem));
            $.when.apply($, refreshPromises).then(function () {
                Mail.render($elem);
            });
        });
        Mail.keepDropdownOpen($elem);
    }
    static deleteAttachmentsOrImportFilesCore($elem, attachments, guids) {
        let d = $.Deferred();
        const synData = $elem.data("synMail");
        synData.ajaxCallInProgress = true;
        Utilities_1.synUtil.getAJAXData({
            method: "PUT",
            url: attachments ? Utilities_1.synUtil.getWSUrl("IntegrationDeleteAttachments") : Utilities_1.synUtil.getWSUrl("IntegrationDeleteImportFiles"),
            requestData: { fileguids: guids.join(";") },
            done(data) {
                synData.ajaxCallInProgress = false;
                $elem.trigger("afterDelete", guids);
                d.resolve();
            },
            cleanUp() {
                synData.ajaxCallInProgress = false;
            }
        });
        return d.promise();
    }
    static keepDropdownOpen($elem) {
        const synData = $elem.data('synMail');
        clearTimeout(synData.doCloseDropdown);
        synData.allowCloseDropdown = false;
        synData.doCloseDropdown = setTimeout(function () { synData.allowCloseDropdown = true; }, 300);
    }
    static render($elem) {
        const synData = $elem.data("synMail");
        let $mailItems = $elem.find(".mail_items").html("");
        let messageItems = _.first(synData.mailItems.messages, synData.maxitems);
        let attachmentItems = _.first(synData.mailItems.attachments, synData.maxitems);
        let importFileKeys = _.first(Object.keys(synData.importFileItems), synData.maxitems);
        if (messageItems.length === 0 && attachmentItems.length === 0 && importFileKeys.length === 0) {
            $elem.find(".badge").text("0").hide();
            $mailItems.append($("<h4></h4>").text(Utilities_1.synUtil.Strings.getValue("listemtpy")));
        }
        else {
            $elem.find('.badge').text(messageItems.length + attachmentItems.length + importFileKeys.length).show();
            if (messageItems.length > 0) {
                $mailItems.append($("<h4></h4>").text(Utilities_1.synUtil.Strings.getValue("synmails")));
                let $allMailCommands = $("<div class='mailLinks'></div>").appendTo($mailItems);
                // insertAllMails
                $("<a class='mailActionLink left'></a>")
                    .text(Utilities_1.synUtil.Strings.getValue("insertall"))
                    .on("click", function () {
                    let fileGuids = $.map(synData.mailItems.messages, function (item) { return item.fileGuid; });
                    Mail.insertMails($elem, fileGuids);
                })
                    .appendTo($allMailCommands);
                // deleteAllMails
                $("<a class='mailActionLink right'></a>")
                    .text(Utilities_1.synUtil.Strings.getValue("deleteall"))
                    .on("click", function () {
                    let fileGuids = $.map(synData.mailItems.messages, function (item) { return item.fileGuid; });
                    Mail.deleteMails($elem, fileGuids);
                })
                    .appendTo($allMailCommands);
                $.each(messageItems, function (idx, item) {
                    let $div = $("<div class='mailEntry' data-type='message' data-id='" + item.fileGuid + "'></div>").appendTo($mailItems);
                    let $commands = $("<div class='commands'></div>").appendTo($div);
                    $commands.append("<a class='insertCommand' title='" + Utilities_1.synUtil.Strings.getValue("importmail") + "'><i class='fa fa-sign-in fa-flip-horizontal'></i></a>");
                    let cefunc2Icon = Utilities_1.synUtil.getWSUrl("Icon") + "name=cefunc.2.ico/16";
                    $commands.append("<a class='insertCommandPE' title='" + Utilities_1.synUtil.Strings.getValue('importmailpe') + "'><img class='k-image' src='" + cefunc2Icon + "' /></a>");
                    let tooltip = moment(item.sentOn, "ddd DD.MM.YYYY HH:mm")
                        + "<h4>" + kendo.htmlEncode(item.senderName) + "</h4>"
                        + "<h5>" + kendo.htmlEncode(item.subject) + "</h5>"
                        + kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("smapiRecipsTo")) + ' ' + kendo.htmlEncode(item.to);
                    if (item.cc)
                        tooltip += "<br>" + kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("smapiRecipsCc")) + " " + item.cc;
                    // title
                    $("<div class='title mailtooltip'></div>")
                        .attr({
                        "data-toggle": "tooltip",
                        "data-original-title": tooltip
                    })
                        .text(item.subject)
                        .appendTo($div);
                    let $delete = $("<div class='delete'></div>").appendTo($div);
                    $delete.append("<a class='deleteCommand'><i class='fa fa-times'></i></a>");
                });
                if (synData.mailItems.messages.length > synData.maxitems)
                    $mailItems.append($("<div class='numInfo'></div>").text("(" + synData.maxitems + " " + kendo.format(Utilities_1.synUtil.Strings.getValue("listof"), synData.mailItems.messages.length) + ")"));
            }
            if (messageItems.length > 0 && attachmentItems.length > 0)
                $mailItems.append("<hr />");
            if (attachmentItems.length > 0) {
                $mailItems.append($("<h4></h4>").text(Utilities_1.synUtil.Strings.getValue("synattachments")));
                let $allAttachmentCommands = $("<div class='attachmentLinks'></div>").appendTo($mailItems);
                // insertAllAttachments
                $("<a class='attachmentActionLink left'></a>")
                    .text(Utilities_1.synUtil.Strings.getValue("insertall"))
                    .on("click", function () {
                    let fileGuids = $.map(synData.mailItems.attachments, function (item) { return item.fileGuid; });
                    Mail.insertAttachmentsOrFiles($elem, fileGuids);
                })
                    .appendTo($allAttachmentCommands);
                // deleteAllAttachments
                $("<a class='attachmentActionLink right'></a>")
                    .text(Utilities_1.synUtil.Strings.getValue("deleteall"))
                    .on("click", function () {
                    let fileGuids = $.map(synData.mailItems.attachments, function (item) { return item.fileGuid; });
                    Mail.deleteAttachmentsOrImportFiles($elem, fileGuids);
                })
                    .appendTo($allAttachmentCommands);
                $.each(attachmentItems, function (idx, item) {
                    let $div = $("<div class='attachmentEntry' data-type='attachment' data-id='" + item.fileGuid + "'></div>").appendTo($mailItems);
                    let $commands = $("<div class='commands'></div>").appendTo($div);
                    $commands.append("<a class='insertCommand' title='" + Utilities_1.synUtil.Strings.getValue("importattachment") + "'><i class='fa fa-sign-in fa-flip-horizontal'></i></a>");
                    $("<div class='title'></div>").text(item.filename).appendTo($div);
                    let $delete = $("<div class='delete'></div>").appendTo($div);
                    $delete.append("<a class='deleteCommand'><i class='fa fa-times'></i></a>");
                });
                if (synData.mailItems.attachments.length > synData.maxitems)
                    $mailItems.append($("<div class='numInfo'></div>").text("(" + synData.maxitems + " " + kendo.format(Utilities_1.synUtil.Strings.getValue("listof"), synData.mailItems.attachments.length) + ")"));
            }
            if ((messageItems.length > 0 || attachmentItems.length > 0) && importFileKeys.length > 0)
                $mailItems.append("<hr />");
            if (importFileKeys.length > 0) {
                $mailItems.append($("<h4></h4>").text(Utilities_1.synUtil.Strings.getValue("synimportfiles")));
                let $fileLinksCommands = $("<div class='fileLinks'></div>").appendTo($mailItems);
                // insertAllFiles
                $("<a class='fileActionLink left'></a>")
                    .text(Utilities_1.synUtil.Strings.getValue("insertall"))
                    .on("click", function () {
                    Mail.insertAttachmentsOrFiles($elem, importFileKeys);
                })
                    .appendTo($fileLinksCommands);
                // deleteAllFiles
                $("<a class='fileActionLink right'></a>")
                    .text(Utilities_1.synUtil.Strings.getValue("deleteall"))
                    .on("click", function () {
                    Mail.deleteAttachmentsOrImportFiles($elem, importFileKeys);
                })
                    .appendTo($fileLinksCommands);
                let importFiles = [];
                for (let i = 0; i < importFileKeys.length; ++i)
                    importFiles.push(synData.importFileItems[importFileKeys[i]]);
                importFiles.sort(function (a, b) { return a.filename.localeCompare(b.filename); });
                for (let i = 0; i < importFiles.length; ++i) {
                    let importFile = importFiles[i];
                    let $fileDiv = $("<div class='fileEntry' data-type='file' data-id='" + importFile.fileGuid + "'></div>").appendTo($mailItems);
                    let $fileCommands = $("<div class='commands'></div>").appendTo($fileDiv);
                    $fileCommands.append("<a class='insertCommand' title='" + Utilities_1.synUtil.Strings.getValue("importfile") + "'><i class='fa fa-sign-in fa-flip-horizontal'></i></a>");
                    $("<div class='title'></div>").text(importFile.filename).appendTo($fileDiv);
                    let $delete = $("<div class='delete'></div>").appendTo($fileDiv);
                    $delete.append("<a class='deleteCommand'><i class='fa fa-times'></i></a>");
                }
                if (synData.mailItems.attachments.length > synData.maxitems)
                    $mailItems.append($("<div class='numInfo'></div>").text("(" + synData.maxitems + " " + kendo.format(Utilities_1.synUtil.Strings.getValue("listof"), synData.mailItems.attachments.length) + ")"));
            }
            $elem.find("a.insertCommand").on("click", function () {
                let $entry = $(this).closest(".mailEntry,.attachmentEntry,.fileEntry");
                let fileGuid = $entry.attr("data-id");
                let type = $entry.attr("data-type");
                if (type === "message")
                    Mail.insertMails($elem, [fileGuid]);
                else if (type === "attachment" || type === "file")
                    Mail.insertAttachmentsOrFiles($elem, [fileGuid]);
            });
            $elem.find("a.insertCommandPE").on("click", function () {
                let $mailEntry = $(this).closest(".mailEntry");
                let fileGuid = $mailEntry.attr("data-id");
                let type = $mailEntry.attr("data-type");
                if (type === "message")
                    Mail.insertMailPE($elem, fileGuid);
            });
            $elem.find("a.deleteCommand").on("click", function () {
                let $mailEntry = $(this).closest(".mailEntry,.attachmentEntry,.fileEntry");
                let fileGuid = $mailEntry.attr("data-id");
                let type = $mailEntry.attr("data-type");
                if (type === "message")
                    Mail.deleteMails($elem, [fileGuid]);
                else if (type === "attachment" || type === "file")
                    Mail.deleteAttachmentsOrImportFiles($elem, [fileGuid]);
                Mail.keepDropdownOpen($elem);
            });
        }
        if ($elem.hasClass("open"))
            $elem.find("a.btn").addClass("btn-primary");
        else
            $elem.find("a.btn").removeClass("btn-primary");
    }
}
exports.Mail = Mail;
// Dispatcher code
(($) => {
    $.fn.synMail = function (method) {
        if (Mail[method])
            return Mail[method].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else if (typeof method === "object" || !method)
            return Mail.init(this, arguments[0]);
        else
            $.error("Method " + method + " does not exist on jQuery.SynMail");
    };
})(jQuery);
